import { render, staticRenderFns } from "./ShareLink.vue?vue&type=template&id=c84e3fd8&scoped=true"
import script from "./ShareLink.vue?vue&type=script&lang=js"
export * from "./ShareLink.vue?vue&type=script&lang=js"
import style0 from "./ShareLink.vue?vue&type=style&index=0&id=c84e3fd8&prod&lang=scss"
import style1 from "./ShareLink.vue?vue&type=style&index=1&id=c84e3fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84e3fd8",
  null
  
)

export default component.exports